import React from 'react';
import './Banner.scss';

const Banner = () => (
  <section className="banner">
    <h1 className="banner__heading">Cost Estimation - Small Projects</h1>
    <p className="banner__description">
      Calculate a custom quote for your project with the Cost calculator.
    </p>
  </section>
);

export default Banner;
